import Image from 'next/image';
import { useRef, useState } from 'react';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { useRouter } from 'next/router';



const ServicesAbout = ({image, text, title}) => {

  const sectionRef= useRef(null)
  const titleRef= useRef(null)
  const containerRef = useRef(null)
  const textRef= useRef(null)

  const router = useRouter()
  const { locale } = router

  const [showAllText, setShowAllText] = useState(false)


    useGSAP(() => {
    const mm = gsap.matchMedia();

    mm.add("(min-width: 1280px)", () => {


      
      gsap.fromTo(containerRef.current, {
        y: '13rem'
      },
          {
        y: 0,
        ease: "none",
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top bottom", 
          end: "top 55%",  
          scrub: 0.1,  
        },
      });
      

      gsap.fromTo(titleRef.current, { opacity: 0, x: '4rem' }, {
        opacity: 1,
        x: 0,
        duration: 0.7,
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 70%",
        },
      });

      gsap.fromTo(textRef.current, { opacity: 0, x: '4rem' }, {
        opacity: 1,
        x: 0,
        delay: 0.2,
        duration: 0.7,
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 70%",
        },
      });


    });

    return () => mm.revert();
  }, {scope: sectionRef});
  
  return (
    <section ref={sectionRef} className="container-max py-[4rem]  container-padding  md:py-[5rem] lg:py-[6rem] xl:py-[8rem]  relative">
        <div ref={containerRef} className='container-grid flex-col lg:items-start w-full overflow-hidden'>

          <div  className="md:col-span-2 lg:col-span-3 lg:col-start-3 relative hidden md:block w-full aspect-[0.65] ">
            <Image
              src={image?.url}
              alt={image?.alt}
              fill
              sizes="(max-width: 768px) 600px, 900px"
              className="w-auto object-cover"
            />
          </div>


        <div className='md:col-span-2 lg:col-span-6 lg:col-start-7 md:mt-[1rem]  xl:mt-[10rem] w-full md:col-start-4 flex flex-col justify-start'>


        <h2 ref={titleRef} className='heading-3 lg:mb-4rem md:max-w-[60rem] lg:max-w-none [&>.selected]:italic [&>.selected]:text-dusty-green-dark mb-[1.6rem] md:mb-[2rem] lg:mb-[4rem]' dangerouslySetInnerHTML={{__html: title}}/>
        <div ref={textRef} className="mb-[4rem] lg:mb-0">
          <div className=' '>
            <>
              {text ? <p className="text-1 max-w-[37rem] lg:max-w-[59%]" dangerouslySetInnerHTML={{__html: text[0].text}}/> : null}
            </>
            {showAllText? <p className="text-1 max-w-[37rem] lg:max-w-[59%] mt-[1.6rem]" dangerouslySetInnerHTML={{__html: text[1].text}}/> : null}
          </div>
          {!showAllText ?  <button onClick={()=> {setShowAllText(true)}} className="mt-[3.2rem] text-link cursor-pointer text-dark-blue">{locale === 'ru' ? 'показать больше' : 'show more'}</button> : null}
        </div>

        </div>


          <div  className="relative md:hidden w-full aspect-[1.05] ">
            <Image
              src={image?.url}
              alt={image?.alt}
              fill
              
              sizes="100vw"
              className="w-auto object-cover"
            />
          </div>
          
        </div>
    </section>
  );
};

export default ServicesAbout;